import PhoneNumberHighlighting from './phone_number_highlighting';
export default PhoneNumberHighlighting;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/text_editor/plugins/phone_number_highlighting/index.js